module.exports = __WEBPACK_EXTERNAL_MODULE__796d__;